package com.upcominds.expedite.web

import androidx.compose.runtime.*
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

/**
 * Minimal Flow->State bridge for Compose Web.
 *
 * (No lifecycle APIs on web; we cancel collection on dispose.)
 */
@Composable
fun <T> StateFlow<T>.collectAsStateWeb(
    scope: CoroutineScope = rememberCoroutineScope()
): State<T> {
    val state = remember { mutableStateOf(value) }

    DisposableEffect(this) {
        val job = scope.launch {
            collect { state.value = it }
        }
        onDispose { job.cancel() }
    }

    return state
}

@Composable
fun <T> Flow<T>.collectAsStateWeb(
    initial: T,
    scope: CoroutineScope = rememberCoroutineScope()
): State<T> {
    val state = remember { mutableStateOf(initial) }

    DisposableEffect(this) {
        val job = scope.launch {
            collect { state.value = it }
        }
        onDispose { job.cancel() }
    }

    return state
}
